module.exports = __webpack_public_path__ + "img/20.9888b60b.png";